const isTimesFilled = (horaEntrada, horaSaida) => {

    return horaEntrada !== null && horaEntrada !== '' && horaEntrada.length === 8
        && horaSaida !== null && horaSaida !== '' && horaSaida.length === 8
}

export default {
    validate: (horaEntrada, { periodo, horaSaida }) => {

        if (!isTimesFilled(horaEntrada, horaSaida)) return true

        const inicioSplit = horaEntrada.split(':')
        const fimSplit = horaSaida.split(':')

        const inicio = new Date(periodo.start.getTime())

        inicio.setHours(inicioSplit[0])
        inicio.setMinutes(inicioSplit[1])

        const fim = new Date(periodo.end.getTime())

        fim.setHours(fimSplit[0])
        fim.setMinutes(fimSplit[1])

        const diffInHours = (fim.getTime() - inicio.getTime()) / (1000 * 3600)

        if (diffInHours <= 0) {

            return 'Essa escala é para o mesmo dia e, portanto, ' +
                'o Horário de Saída deve ser superior ao Horário de Entrada!'
        }

        return true
    },
    params: ['periodo', 'horaSaida'],
}